// Shared news data for News listing and Article pages

export interface NewsItem {
  id: number
  slug: string
  date: string
  date_ar: string
  title: string
  title_ar: string
  category: 'product-launches' | 'partnerships' | 'milestones'
  image: string
  content: string[]
  content_ar: string[]
}

export const newsItems: NewsItem[] = [
  {
    id: 1,
    slug: 'cscbank-expands-digital-wallet-capabilities-across-mena',
    date: 'Nov 2, 2025',
    date_ar: '2 نوفمبر 2025',
    title: 'CSCBank Expands Digital Wallet Capabilities Across MENA',
    title_ar:
      'CSCBank توسّع قدرات المحفظة الرقمية عبر منطقة الشرق الأوسط وشمال أفريقيا',
    category: 'product-launches',
    image:
      'https://cdn.magicpatterns.com/uploads/3GFQo6EiGsuXFaC4RyVTxS/Mask_Group_177.png',
    content: [
      'CSCBank has announced a major upgrade to its digital wallet services, reinforcing its commitment to providing innovative, secure, and seamless payment solutions across the Middle East and North Africa (MENA) region.',
      'The expansion includes enhanced features such as instant peer-to-peer transfers, multi-currency support, biometric authentication, and integration with popular e-commerce platforms. Customers can now enjoy faster transactions, improved security, and a more user-friendly experience, whether shopping online, transferring funds, or paying bills.',
      '"Our goal is to empower individuals and businesses with cutting-edge financial technology that simplifies their daily lives," said [Insert Executive Name], [Insert Title] at CSCBank. "This expansion represents our vision to become a leading player in the digital payments space across MENA."',
      'The enhanced wallet capabilities will initially roll out in key markets, including the UAE, Saudi Arabia, Egypt, and Lebanon, with plans to cover additional countries by the end of the year. CSCBank also plans to introduce value-added features such as loyalty programs, QR-based payments, and integrations with emerging fintech ecosystems.',
      "This initiative reflects CSCBank's continued investment in digital transformation and its focus on meeting the evolving needs of its customers in an increasingly digital world.",
    ],
    content_ar: [
      'أعلن CSCBank عن ترقية كبيرة لخدمات المحفظة الرقمية، مما يعزز التزامه بتقديم حلول دفع مبتكرة وآمنة وسلسة عبر منطقة الشرق الأوسط وشمال أفريقيا.',
      'يشمل التوسع ميزات محسّنة مثل التحويلات الفورية بين الأفراد، ودعم العملات المتعددة، والمصادقة البيومترية، والتكامل مع منصات التجارة الإلكترونية الشائعة. يمكن للعملاء الآن الاستمتاع بمعاملات أسرع وأمان محسّن وتجربة أكثر سهولة.',
      '"هدفنا هو تمكين الأفراد والشركات بتكنولوجيا مالية متطورة تبسّط حياتهم اليومية"، قال المسؤول التنفيذي في CSCBank. "يمثل هذا التوسع رؤيتنا لنصبح لاعباً رائداً في مجال المدفوعات الرقمية عبر المنطقة."',
      'ستُطلق قدرات المحفظة المحسّنة في البداية في الأسواق الرئيسية، بما في ذلك الإمارات والسعودية ومصر ولبنان، مع خطط لتغطية دول إضافية بحلول نهاية العام.',
      'تعكس هذه المبادرة استثمار CSCBank المستمر في التحول الرقمي وتركيزه على تلبية الاحتياجات المتطورة لعملائه في عالم رقمي متزايد.',
    ],
  },
  {
    id: 2,
    slug: 'strategic-partnership-with-global-fintech-leaders',
    date: 'Oct 15, 2025',
    date_ar: '15 أكتوبر 2025',
    title: 'Strategic Partnership with Global FinTech Leaders',
    title_ar: 'شراكة استراتيجية مع قادة التكنولوجيا المالية العالميين',
    category: 'partnerships',
    image:
      'https://cdn.magicpatterns.com/uploads/dCUqoGbF6S2j3EZvLmqJov/Mask_Group_178.png',
    content: [
      'CSC Group has announced a strategic partnership with leading global fintech companies to enhance its digital payment infrastructure and expand its service offerings across the region.',
      'This collaboration brings together industry expertise and cutting-edge technology to deliver innovative financial solutions that meet the evolving needs of businesses and consumers.',
      'The partnership will focus on developing new payment technologies, improving transaction security, and creating seamless integration capabilities for merchants and financial institutions.',
      '"This partnership marks a significant milestone in our journey to become a leader in digital financial services," said the CEO of CSC Group. "Together, we will drive innovation and deliver exceptional value to our customers."',
    ],
    content_ar: [
      'أعلنت مجموعة CSC عن شراكة استراتيجية مع شركات التكنولوجيا المالية العالمية الرائدة لتعزيز بنيتها التحتية للمدفوعات الرقمية وتوسيع عروض خدماتها عبر المنطقة.',
      'يجمع هذا التعاون بين الخبرة الصناعية والتكنولوجيا المتطورة لتقديم حلول مالية مبتكرة تلبي الاحتياجات المتطورة للشركات والمستهلكين.',
      'ستركز الشراكة على تطوير تقنيات دفع جديدة وتحسين أمان المعاملات وإنشاء قدرات تكامل سلسة للتجار والمؤسسات المالية.',
      '"تمثل هذه الشراكة علامة فارقة في رحلتنا لنصبح رائدين في الخدمات المالية الرقمية"، قال الرئيس التنفيذي لمجموعة CSC.',
    ],
  },
  {
    id: 3,
    slug: 'csc-group-celebrates-30-years-of-excellence',
    date: 'Sep 28, 2025',
    date_ar: '28 سبتمبر 2025',
    title: 'CSC Group Celebrates 30 Years of Excellence',
    title_ar: 'مجموعة CSC تحتفل بـ 30 عاماً من التميز',
    category: 'milestones',
    image:
      'https://cdn.magicpatterns.com/uploads/krKNqESzVkVmyQ2HbjeyhG/Mask_Group_179.png',
    content: [
      'CSC Group proudly celebrates its 30th anniversary, marking three decades of excellence in payment solutions and financial technology services across the Middle East and Africa.',
      'Since its founding in 1995, CSC Group has grown from a small regional player to a leading provider of comprehensive payment solutions, serving banks, financial institutions, and businesses across multiple countries.',
      'Over the years, the company has pioneered numerous innovations in card issuing, ATM acquiring, merchant services, and mobile payments, establishing itself as a trusted partner for digital transformation.',
      '"This milestone is a testament to the dedication of our team and the trust of our partners and clients," said the Chairman of CSC Group. "We look forward to continuing our journey of innovation and growth for the next 30 years and beyond."',
    ],
    content_ar: [
      'تحتفل مجموعة CSC بفخر بالذكرى السنوية الثلاثين لتأسيسها، مسجلةً ثلاثة عقود من التميز في حلول الدفع وخدمات التكنولوجيا المالية عبر الشرق الأوسط وأفريقيا.',
      'منذ تأسيسها في عام 1995، نمت مجموعة CSC من لاعب إقليمي صغير إلى مزود رائد لحلول الدفع الشاملة، تخدم البنوك والمؤسسات المالية والشركات عبر دول متعددة.',
      'على مر السنين، ابتكرت الشركة العديد من الابتكارات في إصدار البطاقات وشبكات الصراف الآلي وخدمات التجار والمدفوعات عبر الهاتف المحمول.',
      '"هذا الإنجاز هو شهادة على تفاني فريقنا وثقة شركائنا وعملائنا"، قال رئيس مجلس إدارة مجموعة CSC.',
    ],
  },
  {
    id: 4,
    slug: 'new-data-center-launch-in-cyprus',
    date: 'Aug 10, 2025',
    date_ar: '10 أغسطس 2025',
    title: 'New Data Center Launch in Cyprus',
    title_ar: 'إطلاق مركز بيانات جديد في قبرص',
    category: 'milestones',
    image:
      'https://cdn.magicpatterns.com/uploads/3GFQo6EiGsuXFaC4RyVTxS/Mask_Group_177.png',
    content: [
      'CSC Group has officially launched its new state-of-the-art data center in Cyprus, significantly expanding its infrastructure capabilities and enhancing service reliability for clients across the region.',
      'The new facility features advanced security systems, redundant power supplies, and cutting-edge cooling technology to ensure maximum uptime and data protection.',
      "This investment demonstrates CSC Group's commitment to providing world-class infrastructure that meets the highest international standards for data security and operational excellence.",
    ],
    content_ar: [
      'أطلقت مجموعة CSC رسمياً مركز بياناتها الجديد المتطور في قبرص، مما يوسع بشكل كبير قدراتها في البنية التحتية ويعزز موثوقية الخدمة للعملاء عبر المنطقة.',
      'يتميز المرفق الجديد بأنظمة أمان متقدمة وإمدادات طاقة احتياطية وتكنولوجيا تبريد متطورة لضمان أقصى وقت تشغيل وحماية البيانات.',
      'يُظهر هذا الاستثمار التزام مجموعة CSC بتوفير بنية تحتية عالمية المستوى تلبي أعلى المعايير الدولية لأمن البيانات والتميز التشغيلي.',
    ],
  },
  {
    id: 5,
    slug: 'csc-introduces-advanced-fraud-detection-system',
    date: 'Jul 22, 2025',
    date_ar: '22 يوليو 2025',
    title: 'CSC Introduces Advanced Fraud Detection System',
    title_ar: 'CSC تقدم نظام كشف احتيال متقدم',
    category: 'product-launches',
    image:
      'https://cdn.magicpatterns.com/uploads/krKNqESzVkVmyQ2HbjeyhG/Mask_Group_179.png',
    content: [
      'CSC Group has unveiled its next-generation fraud detection system, leveraging artificial intelligence and machine learning to protect customers from increasingly sophisticated financial crimes.',
      'The new system analyzes transaction patterns in real-time, identifying suspicious activities and preventing fraudulent transactions before they occur.',
      "This advanced technology represents a significant upgrade to CSC Group's security infrastructure, providing enhanced protection for cardholders and merchants alike.",
    ],
    content_ar: [
      'كشفت مجموعة CSC عن نظام الجيل التالي للكشف عن الاحتيال، مستفيدةً من الذكاء الاصطناعي والتعلم الآلي لحماية العملاء من الجرائم المالية المتطورة بشكل متزايد.',
      'يحلل النظام الجديد أنماط المعاملات في الوقت الفعلي، ويحدد الأنشطة المشبوهة ويمنع المعاملات الاحتيالية قبل حدوثها.',
      'تمثل هذه التكنولوجيا المتقدمة ترقية كبيرة للبنية التحتية الأمنية لمجموعة CSC، مما يوفر حماية معززة لحاملي البطاقات والتجار على حد سواء.',
    ],
  },
  {
    id: 6,
    slug: 'regional-expansion-new-office-in-saudi-arabia',
    date: 'Jun 5, 2025',
    date_ar: '5 يونيو 2025',
    title: 'Regional Expansion: New Office in Saudi Arabia',
    title_ar: 'التوسع الإقليمي: مكتب جديد في المملكة العربية السعودية',
    category: 'milestones',
    image:
      'https://cdn.magicpatterns.com/uploads/dCUqoGbF6S2j3EZvLmqJov/Mask_Group_178.png',
    content: [
      'CSC Group has opened a new regional office in Riyadh, Saudi Arabia, marking a significant expansion of its presence in the Gulf region.',
      'The new office will serve as a hub for business development, client services, and technical support, enabling CSC Group to better serve its growing customer base in the Kingdom.',
      "This expansion aligns with Saudi Arabia's Vision 2030 initiative and the country's rapid digital transformation in the financial services sector.",
    ],
    content_ar: [
      'افتتحت مجموعة CSC مكتباً إقليمياً جديداً في الرياض، المملكة العربية السعودية، مما يمثل توسعاً كبيراً لوجودها في منطقة الخليج.',
      'سيكون المكتب الجديد مركزاً لتطوير الأعمال وخدمات العملاء والدعم الفني، مما يمكّن مجموعة CSC من خدمة قاعدة عملائها المتنامية في المملكة بشكل أفضل.',
      'يتماشى هذا التوسع مع مبادرة رؤية السعودية 2030 والتحول الرقمي السريع للبلاد في قطاع الخدمات المالية.',
    ],
  },
  {
    id: 7,
    slug: 'csc-partners-with-leading-african-banks',
    date: 'May 18, 2025',
    date_ar: '18 مايو 2025',
    title: 'CSC Partners with Leading African Banks',
    title_ar: 'CSC تتشارك مع البنوك الأفريقية الرائدة',
    category: 'partnerships',
    image:
      'https://cdn.magicpatterns.com/uploads/3GFQo6EiGsuXFaC4RyVTxS/Mask_Group_177.png',
    content: [
      "CSC Group has announced partnerships with several leading banks across Africa, expanding its footprint in the continent's rapidly growing financial services market.",
      'These partnerships will enable CSC Group to provide its comprehensive suite of payment solutions to millions of new customers across multiple African countries.',
      "The expansion into Africa represents a strategic move to tap into one of the world's fastest-growing markets for digital financial services.",
    ],
    content_ar: [
      'أعلنت مجموعة CSC عن شراكات مع عدة بنوك رائدة عبر أفريقيا، موسعةً بصمتها في سوق الخدمات المالية سريع النمو في القارة.',
      'ستمكّن هذه الشراكات مجموعة CSC من تقديم مجموعتها الشاملة من حلول الدفع لملايين العملاء الجدد عبر دول أفريقية متعددة.',
      'يمثل التوسع في أفريقيا خطوة استراتيجية للاستفادة من أحد أسرع الأسواق نمواً في العالم للخدمات المالية الرقمية.',
    ],
  },
  {
    id: 8,
    slug: 'new-mobile-payment-solution-launched',
    date: 'Apr 3, 2025',
    date_ar: '3 أبريل 2025',
    title: 'New Mobile Payment Solution Launched',
    title_ar: 'إطلاق حل جديد للدفع عبر الهاتف المحمول',
    category: 'product-launches',
    image:
      'https://cdn.magicpatterns.com/uploads/krKNqESzVkVmyQ2HbjeyhG/Mask_Group_179.png',
    content: [
      'CSC Group has launched an innovative mobile payment solution designed to make digital transactions more accessible and convenient for users across the region.',
      'The new platform supports multiple payment methods, including QR codes, NFC, and in-app payments, providing flexibility for both consumers and merchants.',
      'With a focus on user experience and security, the solution aims to accelerate the adoption of cashless payments in emerging markets.',
    ],
    content_ar: [
      'أطلقت مجموعة CSC حل دفع مبتكر عبر الهاتف المحمول مصمم لجعل المعاملات الرقمية أكثر سهولة وملاءمة للمستخدمين عبر المنطقة.',
      'تدعم المنصة الجديدة طرق دفع متعددة، بما في ذلك رموز QR وNFC والمدفوعات داخل التطبيق، مما يوفر مرونة لكل من المستهلكين والتجار.',
      'مع التركيز على تجربة المستخدم والأمان، يهدف الحل إلى تسريع اعتماد المدفوعات غير النقدية في الأسواق الناشئة.',
    ],
  },
  {
    id: 9,
    slug: 'csc-achieves-iso-27001-certification',
    date: 'Mar 12, 2025',
    date_ar: '12 مارس 2025',
    title: 'CSC Achieves ISO 27001 Certification',
    title_ar: 'CSC تحصل على شهادة ISO 27001',
    category: 'milestones',
    image:
      'https://cdn.magicpatterns.com/uploads/dCUqoGbF6S2j3EZvLmqJov/Mask_Group_178.png',
    content: [
      'CSC Group has achieved ISO 27001 certification, the international standard for information security management systems.',
      "This certification demonstrates CSC Group's commitment to maintaining the highest standards of data security and privacy protection for its clients and partners.",
      "The achievement follows a rigorous audit process and reflects the company's ongoing investment in security infrastructure and best practices.",
    ],
    content_ar: [
      'حصلت مجموعة CSC على شهادة ISO 27001، المعيار الدولي لأنظمة إدارة أمن المعلومات.',
      'تُظهر هذه الشهادة التزام مجموعة CSC بالحفاظ على أعلى معايير أمن البيانات وحماية الخصوصية لعملائها وشركائها.',
      'يأتي هذا الإنجاز بعد عملية تدقيق صارمة ويعكس استثمار الشركة المستمر في البنية التحتية الأمنية وأفضل الممارسات.',
    ],
  },
]

export function getNewsItemBySlug(slug: string): NewsItem | undefined {
  return newsItems.find((item) => item.slug === slug)
}

export function getRelatedNews(
  currentSlug: string,
  limit: number = 3,
): NewsItem[] {
  return newsItems.filter((item) => item.slug !== currentSlug).slice(0, limit)
}
